import { svg } from "lit";
const icon = svg `<path d="M5.8335 34.1672V5.83398H19.999V7.92794H7.92745V32.0733H19.999V34.1672H5.8335ZM27.5813 26.6031L26.0878 25.1053L30.1455 21.0476H15.1604V18.9537H30.1113L26.0536 14.8959L27.5365 13.3874L34.1667 20.023L27.5813 26.6031Z" fill="currentColor"/>`;
export default icon;
